import { ENV, PROD, QA, QA_BETA } from "./Config"

/* Application list */
export const OXE_LOGIN = "oxe_login"
export const SYSTEM = "system"
export const USERS_CONFIG = "easy_users_service"
export const SIP_TRUNK = "easy_SIP_trunk_service"
export const EXPERT_CONFIG = "expert_config_service"
export const FLEET_DASHBOARD = "fleet_dashboard_portal"
export const SUBSCRIPTION = "service_manager_portal"
export const RAINBOW = "rainbow_admin_portal"
export const LINKS = "umc_links"
export const WHATS_NEW = "whats_new"

/* Services list */
export const SERVICE_IAM = "iam"
export const SERVICE_IAM_SSO = "iam-sso"
export const SERVICE_EASYUUM = "easyuum"
export const SERVICE_EASY_SIPTRUNK = "easysiptrunk"
export const SERVICE_EXPERT_CONF = "expertconfig"
export const SERVICE_AIDOC = "aidoc"
export const SERVICE_OPERATION = "operation"
export const SERVICE_OXESYNC = "oxesync"

/* Widget types */
export const TEXTFIELD = "TEXTFIELD"
export const TEXTFIELDNEW = "TEXTFIELDNEW"
export const TEXTAREA = "TEXTAREA"
export const COMBOBOX = "COMBOBOX"
export const IMAGEGROUP = "IMAGEGROUP"
export const IMAGESINGLE = "IMAGESINGLE"
export const DATEFIELD = "DATEFIELD"
export const CHECKBOX = "CHECKBOX"
export const COLLAPSE = "COLLAPSE"
export const PASSWORD = "PASSWORD"
export const RADIOBUTTON = "RADIOBUTTON"
export const LINKWIDGET = "LINKWIDGET"
export const CUSTOMCOMBOBOX = "CUSTOMCOMBOBOX"

/* Other Constants */

export const SUCCESS = "SUCCESS"
export const STRING = "STRING"
export const SIMPLE_ENUM = "SIMPLE_ENUM"
export const TRUE = "true"
export const OTHERS = "others"
export const IS_POD = "isPod"
export const CC_PRODUCT_ID = "ccproductid"
export const PROJECT_ID = "projectid"
export const ROLE = "role"
export const SESSION_INDEX = "sIndex"
export const NAME_ID = "nameId"
export const USERNAME = "userName"
export const GIVENNAME = "givenName"
export const SURNAME = "surName"
export const TOKEN_1 = "token1"
export const TOKEN_2 = "token2"
export const OXE_UMC_CONNECTED = "oxeConnected"
export const OXE_CLIENT_INFO = "oxeClientInfo"
export const TBL_PAGE_SIZE = "TablePageSize"
export const HELP = "help"
export const REFRESH = "refresh"
export const UPDATE = "UPDATE"
export const CREATE = "CREATE"
export const UNAUTHORIZED = "UNAUTHORIZED"
export const OXE_DISCONNECTION = "OXE_DISCONNECTION"
export const SELECT_ALL = "Select All"
export const DISCRIPTION = "description"
export const INACTIVE_TIME = 1800 // 30 minutes
export const INTERNAL = "INTERNAL"
export const NOE = "NOE"
export const SIP = "SIP"
export const SIP_XXX = "SIP-xxx"
export const SIP_XX = "SIP-xx"
export const NOE_ESSENTIAL = "NOE Essential"
export const NOE_ENTERPRISE = "NOE Enterprise"
export const NOE_IPDSP = "NOE_IPDSP"
export const ADD = "ADD"
export const EDIT = "EDIT"
export const COPY = "COPY"
export const MOVE = "MOVE"
export const DELETE = "DELETE"
export const COPY_ACTIVE = "COPY_ACTIVE"
export const MOVE_ACTIVE = "MOVE_ACTIVE"
export const DELETE_ACTIVE = "DELETE_ACTIVE"
export const FUNCTION = "FUNCTION"
export const FUNC_DETAIL = "FUNC_DETAIL"
export const OXE_ERROR = "oxe_error"

/* EasyUUM Tabs */
export const USERS = "Users"
export const DSS = "dss"
export const PROFILES = "Profiles"
export const USERS_PROFILE = "Users_Profile"
export const PROGKEYS_PROFILE = "ProgKeys_Profile"
export const GROUPS = "Groups"
export const PICKUP_GROUP = "Pickup_Group"
export const HUNTING_GROUP = "Hunting_Group"
export const DIRECTORY_SYNCHRO = "Directory_synchro"


/* CONSTANT ITEMS */

export const TABLE_ROW_ACTIONS = [
  {
    key: 'tbl-modify',
    label: 'Modify'
  },
  {
    key: 'tbl-delete',
    label: 'Delete',
    danger: true,
  },
]

export const PROFILE_TOGGLE_ITEMS = [{
  label: "LABEL_USER_PROF",
  value: true
}, {
  label: "LABEL_PROG_KEYS_PROF",
  value: false,
  disabled: (ENV === PROD || ENV === QA || ENV === QA_BETA) ? true : false,
  title: (ENV === PROD || ENV === QA) ? "Under development..." : ""
}]

export const GROUP_TOGGLE_ITEMS = [{
  label: "LABEL_PICKUP_GROUP",
  value: true
}, {
  label: "PARAM_HUNTING_GROUP",
  value: false,
  disabled:false
}]


export const LANG_LIST = [
  { value: "en-US", label: "English", key: "en" },
  { value: "fr-FR", label: "Français", key: "fr" },
  { value: "de-DE", label: "Deutsch", key: "de" },
  { value: "sp-ES", label: "Español", key: "es" }]


export const LINKS_LIST = [
  {
    key: "ALE public portal",
    label: "LABEL_ALE_PORTAL_TITLE",
    link: "https://al-enterprise.com/",
    image: "img_ale_portal.png",
    description: "LABEL_ALE_PORTAL"
  },
  {
    key: "ALE eBuy portal",
    label: "LABEL_ALE_EBUY_PORTAL_TITLE",
    link: "https://ebuy.businesspartner.al-enterprise.com/",
    image: "img_ale_ebuy.png",
    description: "LABEL_ALE_EBUY_PORTAL"
  },
  {
    key: "ALE Communication Products portfolio",
    label: "LABEL_ALE_COMM_PROD_PORT_TITLE",
    link: "https://myportal.al-enterprise.com/s/taxonomy/a6f5I0000008TAAQA2/communication-products",
    image: "img_ale_com_prod_portfolio.png",
    description: "LABEL_ALE_COMM_PROD_PORT"
  },
  {
    key: "ALE OmniPCX product",
    label: "LABEL_ALE_OXE_SW_DOC_TITLE",
    link: "https://myportal.al-enterprise.com/s/taxonomy/a6f5I0000008SNWQA2/omnipcx-enterprise",
    image: "img_ale_oxe_sw_doc.png",
    description: "LABEL_ALE_OXE_SW_DOC"
  },
  {
    key: "ALE Rainbow support",
    label: "LABEL_ALE_RAINBOW_SUP_TITLE",
    link: "https://support.openrainbow.com/",
    image: "img_ale_rainbow_sup.png",
    description: "LABEL_ALE_RAINBOW_SUP"
  },
  {
    key: "ALE DECT PARI allocation portal",
    label: "LABEL_ALE_DECT_PARI_ALLOC_TITLE",
    link: "https://ebuy.businesspartner.al-enterprise.com/codepari/menu_paricode.aspx",
    image: "img_dect_pari_alloc.png",
    description: "LABEL_ALE_DECT_PARI_ALLOC"
  },
  {
    key: "ALE EDS",
    label: "LABEL_ALE_EDS_TITLE",
    link: "https://admin.eds.al-enterprise.com/",
    image: "img_ale_eds.png",
    description: "LABEL_ALE_EDS"
  },
  {
    key: "ALE Security Advisories",
    label: "LABEL_ALE_SECURITY_ADV_TITLE",
    link: "https://www.al-enterprise.com/en/support/security-advisories",
    image: "img_ale_security_adv.png",
    description: "LABEL_ALE_SECURITY_ADV"
  },
  {
    key: "Emergency number per country",
    label: "LABEL_EMERGENCY_NO_TITLE",
    link: "https://www.itu.int/net/itu-t/inrdb/e129_important_numbers.aspx",
    image: "img_emergency_no.png",
    description: "LABEL_EMERGENCY_NO"
  },
]

export const ACTION_ITEMS = [{
  title: "LABEL_EDIT", // Dict key
  icon: "icon-modify",
  action: EDIT
}, {
  title: "LABEL_COPY",
  icon: "icon-copy",
  action: COPY
}, {
  title: "LABEL_MOVE",
  icon: "icon-move",
  action: MOVE
}, {
  title: "LABEL_DELETE",
  icon: "remove_icon",
  action: DELETE
}]


export const PROG_KEY_TAB_COUNT = [
  {
    id: SIP_XXX,
    count: [24, 24, 24, 24, 24]
  },
  {
    id: SIP_XX,
    count: [20, 20, 20, 20, 20, 20]
  },
  {
    id: NOE_ESSENTIAL,
    0: [56],
    1: [56, 20, 20, 20],
    2: [56, 20, 20],
    3: [56, 20, 20, 20]
  },
  {
    id: NOE_ENTERPRISE,
    0: [48],
    1: [48, 24, 24, 24],
    2: [48, 24, 24],
    3: [48, 24, 24, 24]
  },
  {
    id: NOE_IPDSP,
    0: [72],
    1: [72, 10],
    2: [72, 40],
    3: [72, 10, 40]
  }
]

export const PK_TOGGLE_OPTIONS = [{ label: "LABEL_PROG_KEYS", value: true }, { label: "LABEL_HARD_KEYS", value: false, disabled: true }]